var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"on-viewport",rawName:"v-on-viewport",value:({
    handler: 'paginate',
  }),expression:"{\n    handler: 'paginate',\n  }"}]},[_c('div',{staticClass:"paginate",staticStyle:{"height":"1px","width":"1px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }